export default __webpack_public_path__ + "static/media/bulkPermissions.184621c5.png";